<template>
  <div class="alert-wrapper">
    <v-alert
      v-if="showWarning"
      density="compact"
      icon="$warning"
      class="alert"
      :text="warningText"></v-alert>
  </div>
</template>

<script>
import brand from '@/composables/useBrand'

export default {
  data () {
    return {
      browser: '',
      isMobilePhone: false
    }
  },
  computed: {
    showWarning () {
      return this.isMobilePhone || !!this.browser
    },
    warningText () {
      if (this.isMobilePhone) {
        return `${brand.name} does not support mobile phones. Please use a computer for the best experience.`
      }

      return `For the best experience, use Chrome instead of ${this.browser} due to potential UI issues.`
    }
  },
  mounted () {
    this.checkBrowser()
  },
  methods: {
    checkBrowser () {
      const ua = navigator.userAgent.toLowerCase()

      this.isMobilePhone =
        ua.includes('iphone') ||
        ua.includes('ipod') ||
        ua.includes('windows phone') ||
        (ua.includes('android') && ua.includes('mobile'))

      if (this.isMobilePhone) {
        return
      }

      if (ua.indexOf('chrome') === -1 && (ua.indexOf('safari') !== -1 || ua.indexOf('firefox') !== -1)) {
        // Safari or Firefox detected
        this.browser = ua.indexOf('safari') !== -1 ? 'Safari' : 'Firefox'
      }
    }
  }
}
</script>

<style scoped>
.alert-wrapper {
  width: 100vw;
  margin-left: -40px;
}

.alert {
  font-size: 14px;
  border-radius: 0;
  background-color: #73E5A6;
  color: var(--white, #ffffff);
}
</style>
